import { NextCustomImage } from 'components/Image';
import ComplexityTag, { type ComplexityTagProps } from 'components/ComplexityTag';
import type { EventData } from 'services/Gtm/entities';
import Link from 'components/Globals/Base/Link';
import Heading from 'styles/typography/Heading';
import RawHtml from 'utils/miscUtils/rawHtml';
import * as S from './CrashCourseCardStyles';

export interface CrashCourseCardProps extends ComplexityTagProps {
  title: string;
  image: string;
  imageAlt: string;
  description: string;
  href: string;
  className?: string;
  trackingData: EventData;
  priority?: boolean;
}

const CrashCourseCard = ({
  title,
  complexity,
  image,
  imageAlt,
  description,
  href,
  className,
  trackingData,
  priority,
}: CrashCourseCardProps) => (
  <S.Card
    className={className}
    data-cy='crashCourseCard'
  >
    <div>
      <S.CardHeader>
        {complexity && <ComplexityTag complexity={complexity} />}
        <Heading
          className='title'
          as='h2'
          $fontFamily='graphikCond'
          $size={{ default: 'level3' }}
          data-cy='crashCourseCardTitle'
        >
          {title}
        </Heading>
      </S.CardHeader>
      <S.CardContent>
        {description && (
          <S.Description data-cy='crashCourseCardDescription'>{RawHtml({ html: description })}</S.Description>
        )}
        {image && (
          <NextCustomImage
            className='crash-course-image'
            data-cy='crashCourseCardImage'
            src={image}
            alt={imageAlt}
            width='276'
            height='188'
            priority={priority}
          />
        )}
        <Link
          type='primaryButton'
          className='learn-more-link'
          href={href}
          ariaLabel={`Go to ${title} course`}
          dataCy='crashCourseCardButton'
          hasRightArrow={false}
          trackingData={{
            ...trackingData,
            contentPlacementCD: 'grid',
            eventAction: 'grid click',
            eventLabel: title,
          }}
        >
          Learn More
        </Link>
      </S.CardContent>
    </div>
  </S.Card>
);

export default CrashCourseCard;
